import { css } from "@emotion/css";
import { BorderRadius, Colors, ShadowValue, Spacing } from "@snapchat/snap-design-system";

export const filterText = css`
    margin: 0 ${Spacing.XS}px;
`;

export const overlayTrigger = css`
    cursor: pointer;

    display: flex;
    align-items: center;

    padding: ${Spacing.XS}px ${Spacing.LG}px;

    line-height: ${Spacing.MD}px;
    color: ${Colors.Black.V100};

    background: ${Colors.WHITE};
    border-radius: ${BorderRadius.button}px;
    outline: 1px solid ${Colors.Gray.V200};
    box-shadow: ${ShadowValue.regular};

    &:hover,
    &:focus,
    &.ant-popover-open {
        outline: ${Spacing["3XS"]}px solid ${Colors.Yellow.V200};
    }
`;

export const overlayContainer = css`
    width: 316px;

    .ant-popover-arrow {
        display: none;
    }

    .ant-popover-inner-content {
        padding: ${Spacing.XS}px;
        border-radius: ${BorderRadius.container}px;
    }
`;

export const overlayItem = css`
    margin: ${Spacing.MD}px;
`;

export const searchBar = css`
    padding: ${Spacing.SM}px ${Spacing.MD}px;
    background: ${Colors.Gray.V50};
    border-radius: ${Spacing["2XS"]}px;

    i {
        color: ${Colors.Gray.V300};
    }

    input {
        color: ${Colors.Gray.V300};
        background: ${Colors.Gray.V50};
    }
`;

export const divider = css`
    border: 1px solid ${Colors.Gray.V150};
`;

export const linkButton = css`
    cursor: pointer;

    margin: ${Spacing.SM}px ${Spacing.MD}px;
    padding: 0;

    color: ${Colors.Blue.V150};

    background: none;
    border: none;

    &:hover,
    &:focus {
        color: ${Colors.Blue.V200};
        text-decoration: underline;
    }
`;
